// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"88":"bb917534","288":"b21fb478","364":"1e35e0ce"}[chunkId] + ".css";
};